import { DepartmentV2 } from '~/types/Department';
import { PilotId } from '~/types/PilotId';

export const createCustomOption = (
  id: PilotId,
  label: string,
): DepartmentV2 => {
  return {
    id: id,
    name: label,
    parent: null,
    path: [],
    members: [],
    members_count: 0,
  };
};
